/**
 * Image component wrapper for next-image-export-optimizer
 * This component automatically uses optimized images in production builds
 * and falls back to original images in development
 */
"use client";

import ExportedImage from "next-image-export-optimizer";
import type { ExportedImageProps } from "next-image-export-optimizer";

// Re-export the ExportedImage component with all its props
export default function Image(props: ExportedImageProps) {
  return <ExportedImage {...props} />;
}

// Re-export types for convenience
export type { ExportedImageProps as ImageProps };
